var exports = {
  "uW": "SettingsSection.module__section___ZzUyQV",
  "bV": "SettingsSection.module__sectionHeader___ZzUyQV",
  "sq": "SettingsSection.module__sectionTitleRow___ZzUyQV",
  "vO": "SettingsSection.module__sectionActions___ZzUyQV",
  "N1": "SettingsSection.module__subsectionActions___ZzUyQV",
  "Gf": "SettingsSection.module__sectionTitle___ZzUyQV",
  "yV": "SettingsSection.module__sectionDescription___ZzUyQV",
  "f5": "SettingsSection.module__sectionContent___ZzUyQV",
  "t8": "SettingsSection.module__subsectionHeader___ZzUyQV",
  "Wf": "SettingsSection.module__subsectionTitle___ZzUyQV",
  "Yq": "SettingsSection.module__subsectionDescription___ZzUyQV",
  "No": "SettingsSection.module__subsectionContent___ZzUyQV",
};

module.exports = exports;
